export const STORE_ORIGIN = 'https://festivalsofindiastore.com';
export const STORE_NAME = 'FESTIVALSOFINDIASTORE';

export const STORE_LINKS = {
  home: STORE_ORIGIN,
  shopAll: STORE_ORIGIN,
  givingBack: `${STORE_ORIGIN}/pages/giving-back`,
  about: `${STORE_ORIGIN}/pages/about-us`,
  shipping: `${STORE_ORIGIN}/pages/shipping-policy`,
  returns: `${STORE_ORIGIN}/pages/returns-refunds`,
  contact: `${STORE_ORIGIN}/pages/contact-us`,
  storePrivacy: `${STORE_ORIGIN}/pages/privacy-policy`,
} as const;
